<div class="contact-container">
    <div class="contact-card">
        <!-- Success Message -->
        @if (successMessage) {
        <div class="alert-card-success">
            <div class="alert-title">Succès !</div>
            <div class="alert-text">{{ successMessage }}</div>
            <button type="button" class="link-button" (click)="createNewContact()">
                Créer une nouvelle demande de contact
            </button>
        </div>
        }

        <!-- Loading State -->
        @if (isLoading) {
        <div class="text-center py-8">
            <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <p class="mt-2 text-gray-600">{{ frenchTranslations.loadingForm }}</p>
        </div>
        }

        <!-- Header -->
        @if (!successMessage && !isLoading) {
        <div class="contact-header">
            <h1>Contactez-nous</h1>
            <h3>Nous sommes là pour répondre à toutes vos questions sur nos services de sécurité.</h3>
        </div>

        <!-- Error Message -->
        @if (errorMessage) {
        <div class="alert alert-error mt-3">
            <p class="form_error">{{ errorMessage }}</p>
        </div>
        }

        <!-- Contact Form -->
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="space-y-6">
            <div class="form-section">
                <div class="form-row">
                    <div class="form-group name-group">
                        <input type="text" id="fullName" formControlName="fullName" [class.error]="hasError('fullName', 'required') || hasError('fullName', 'pattern')" placeholder="Nom complet*" /> @if (hasError('fullName', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('fullName', 'required') }}
                        </div>
                        } @if (hasError('fullName', 'pattern')) {
                        <div class="form_error">
                            {{ getErrorMessage('fullName', 'pattern') }}
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="form-row">
                    <div class="form-group email-group">
                        <input type="email" id="email" formControlName="email" [class.error]="hasError('email', 'required') || hasError('email', 'email')" placeholder="Email*" /> @if (hasError('email', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('email', 'required') }}
                        </div>
                        } @if (hasError('email', 'email')) {
                        <div class="form_error">
                            {{ getErrorMessage('email', 'email') }}
                        </div>
                        }
                    </div>

                    <div class="form-group phone-group">
                        <input type="tel" id="phoneNumber" formControlName="phoneNumber" [class.error]="hasError('phoneNumber', 'pattern')" placeholder="Numéro de téléphone (optionnel)" /> @if (hasError('phoneNumber', 'pattern')) {
                        <div class="form_error">
                            {{ getErrorMessage('phoneNumber', 'pattern') }}
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="form-row">
                    <div class="form-group subject-group">
                        <input type="text" id="subject" formControlName="subject" [class.error]="hasError('subject', 'maxlength')" placeholder="Sujet (optionnel)" /> @if (hasError('subject', 'maxlength')) {
                        <div class="form_error">
                            {{ getErrorMessage('subject', 'maxlength') }}
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="form-row">
                    <div class="form-group message-group">
                        <textarea id="message" formControlName="message" rows="6" [class.error]="hasError('message', 'required') || hasError('message', 'maxlength')" placeholder="Votre message*"></textarea> @if (hasError('message', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('message', 'required') }}
                        </div>
                        } @if (hasError('message', 'maxlength')) {
                        <div class="form_error">
                            {{ getErrorMessage('message', 'maxlength') }}
                        </div>
                        }
                        <div class="helper-text">
                            {{ f['message'].value?.length || 0 }}/2000 caractères
                        </div>
                    </div>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
                <button type="submit" [disabled]="contactForm.invalid || isSubmitting" class="btn submit-btn" [class.loading]="isSubmitting">
                    {{ isSubmitting ? frenchTranslations.sendingMessage : frenchTranslations.sendMessage }}
                </button>
            </div>
        </form>
        }
    </div>

    <div class="image-col">
        <img src="assets/images/call-man.svg" alt="Contactez-nous" class="contact-image">
    </div>
</div>